import { IReduxState } from 'state/types';

export const getSearchParams = (state: IReduxState) =>
  state?.router?.location?.search;

export const getCurrentLocation = (state: IReduxState) =>
  state?.router?.location?.pathname;
